import { render, staticRenderFns } from "./capturePhoto.vue?vue&type=template&id=ba39e27e&scoped=true"
import script from "./capturePhoto.vue?vue&type=script&lang=js"
export * from "./capturePhoto.vue?vue&type=script&lang=js"
import style0 from "./capturePhoto.vue?vue&type=style&index=0&id=ba39e27e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba39e27e",
  null
  
)

export default component.exports